<template>
  <div class="bg-static-default-mid h-12 rounded-[4px]">
    <div
      :aria-label
      aria-valuemax="100"
      aria-valuemin="0"
      :aria-valuenow="value"
      class="h-full rounded-[4px] bg-gradient-to-r from-[#3f55bf] to-[#59de99]"
      role="progressbar"
      :style="{
        width: `${value}%`,
        '--tw-gradient-to-position': `${(100 / value) * 100}%`,
      }"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const { label, value, productName } = defineProps<{
  label: string
  value: number
  productName?: string
}>()

const ariaLabel = computed(() =>
  productName ? `${label} — ${productName}` : label,
)
</script>
